import React, { useState } from 'react'
import { Link } from 'react-router-dom';

import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";

const icons = [
  { name: "Coffee Shop", icon: <FaCoffee /> },
  { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
  { name: "Fish & Seafood", icon: <FaFish /> },
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Restaurant", icon: <FaUtensils /> },
  { name: "Ice Cream", icon: <FaIceCream /> },
  { name: "Chocolate", icon: <FaCookieBite /> },
];

const models = [
  { name: "URBAN", image: "images/moresolutionscase.jpg", description: "Modernity and functionality in a single Bakery and Coffee-Shop wall display concept " },


];
function Moresolutions() {
   const [selectedModels, setSelectedModels] = useState(models);
   
     
       return (
         <div className="w-full font-thin mb-20">
         {/* Hero Section */}
         <section
           className="relative text-center w-full h-[600px]"
           style={{
             backgroundImage: "url('images/moresolutions.jpg')",
             backgroundSize: "cover",
             backgroundPosition: "center",
             backgroundRepeat: "no-repeat",
           }}
         ></section>
   
         {/* Models Display */}
         <section className="px-6 md:px-32">
           <div className="flex flex-col items-center justify-center text-black p-6">
             <h1 className="text-3xl mb-4 md:text-4xl text-center">More Solutions</h1>
             <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
             We have specialist solution for that specific market need.
             </p>
           </div>
   
           <div className="flex justify-center">
             <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
             <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline uppercase mt-6">Typologies</Link>
           </div>
         </section>
   
         {/* Products Grid */}
         <section className="px-2 lg:px-32">
               <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
                 {selectedModels.map((model, index) => (
                   <div key={index} className="text-center">
                    <Link to={`/${model.name.toLowerCase().replace(/\s+/g, "-")}`}>
                       <div
                         className="relative w-full h-80 md:mb-4"
                         style={{
                           backgroundImage: `url(${model.image})`,
                           backgroundSize: "contain",
                           backgroundPosition: "center",
                           backgroundRepeat: "no-repeat",
                           height: "300px",
                         }}
                       ></div>
                       <h3 className="text-3xl font-thin mb-2">{model.name}</h3>
                       <p className="text-lg max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>
                     </Link>
       
                     {/* Small icons under each model */}
                     <div className="flex justify-center gap-4 mt-4">
                       {icons.map((icon, i) => (
                         <div key={i} className="text-2xl text-gray-500 cursor-pointer hover:text-black transition">
                           {icon.icon}
                         </div>
                       ))}
                     </div>
                   </div>
                 ))}
               </div>
             </section>
       </div>
     );
   }
export default Moresolutions